import { Component, HostListener, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { EventconfigStoreService } from '../../shared/eventconfig-store.service';
import { PlayerStoreService } from '../../shared/player-store.service';
import { Question } from '../../shared/question';
import { QuestionStoreService } from '../../shared/question-store.service';
import { ListReorderService } from '../../shared/list-reorder.service';

@Component({
    selector: 'lse-user-vote-question-list-item',
    templateUrl: './user-vote-question-list-item.component.html',
    styleUrls: ['./user-vote-question-list-item.component.css'],
    standalone: false
})
export class UserVoteQuestionListItemComponent implements OnInit {
  @Input() question: Question;
  @Input() user_vote_questions: boolean = false;

  @Output() myEvent = new EventEmitter();
  @Output() tap = new EventEmitter();

  screenwidth = document.body.offsetWidth;
  highlight = false;
  votes = [];
  votedFor = false;
  authorLocation = '';
  initialized = false;
  activeLanguage = 'en';

  constructor(private es: EventconfigStoreService, private vs: PlayerStoreService, private qs: QuestionStoreService,protected listReorderService: ListReorderService) {}

  ngOnInit(): void {
   this.activeLanguage= this.es.getActiveLang();
    this.votes = this.qs.getVotes();
    if (this.votes !== null) {
      if (this.votes.includes(this.question.id)) {
        this.votedFor = true;
      }
    }
    this.authorLocation = this.question.author;
    if (this.question.author === '' || this.question.author === undefined || this.question.location ==='Redaktion') {
      this.authorLocation = 'Anonymous';
    }
    if (this.question.location && this.question.location !== '' && this.question.location !== 'XX' && this.question.location !== 'Redaktion') {
      this.authorLocation += ', ' + this.question.location;
    }
    this.initialized = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question'] && changes['question'].currentValue) {
      const prevVotes = changes['question'].previousValue?.votes ?? 0;
      const currentVotes = changes['question'].currentValue.votes ?? 0;

      if (prevVotes !== currentVotes && this.initialized) {
        this.triggerHighlight();
      }
    }
  }

  private triggerHighlight(): void {
    this.highlight = true;
    setTimeout(() => {
      this.highlight = false;
    }, 500); // Highlight duration in milliseconds
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenwidth = window.innerWidth;
  }

  voteUAQ() {
    this.votedFor = true;
    this.qs.saveVotes(this.question.id);
    this.qs.voteUAQ(this.question.id).subscribe(
      (data) => {

      },
      (err) => {}
    );
/*    console.log(this.qs.saveVotes(this.question.id));*/
  }
}
